export default __webpack_public_path__ + "static/media/bruincard.e663be6b.png";